import React  from 'react'
import ReactDOM from 'react-dom'
import Icon from './icon'
import './menu.css'

/**
 * Menu Icon
 */
class MenuIcon extends React.Component {

  static defaultProps = {
    icon: 'more_vert'
  }

  state = {
    open: false
  }

  toggle = () => {
    const open = !this.state.open
    this.setState({ open })
  }

  render() {
    const { icon } = this.props
    return (
      <div className="menu-icon">
        <Icon icon={icon} action={this.toggle}/>
        { this.state.open === true ? <Menu {...this.props} close={this.toggle}/> : ''}
      </div>
    )
  }
}

/**
 * Menu
 */
class Menu extends React.Component {

  componentDidMount() {
    this.focus()
  }

  componentDidUpdate() {
    this.focus()
  }

  focus() {
    ReactDOM.findDOMNode(this.refs.focusable).focus()
  }

  closer = () => {
    const { close } = this.props
    setTimeout( close, 200 )
  }

  render () {
    const { children, close } = this.props
    return (<div ref="focusable" className="menu-box" tabIndex={0} onMouseUp={this.closer} onBlur={this.closer} autofocus={true}>{children}</div>)
  }
}

/**
 * MenuItem
 */
const MenuItem = ({ id, icon, label, decorator, disabled = false, action }) => {

  const handleClick = () => {
    if (action && !disabled) action(id)
  }

  const stateCSS = disabled ? 'disabled' : ''

  return (
    <li className={`menu-item ${stateCSS} `} onMouseDown={handleClick}>
      {icon  ? <Icon icon={icon} className="small"/> : ''}
      {label ? <label>{label}</label> : ''}
      {decorator ? decorator : ''}
    </li>
  )
}

export { MenuIcon, Menu, MenuItem }



// WEBPACK FOOTER //
// ./src/lib/components/menu.js